<template>
    <CatalogCategories />
    <CatalogTemplates />
</template>

<script setup>
import CatalogCategories from '@/components/GlobalCatalog/CatalogCategories.vue'
import CatalogTemplates from '@/components/GlobalCatalog/CatalogTemplates.vue'
</script>